import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiGetOrgunits, apiUpdateOrgunit } from "../../../api/ApiOrgunit";
import ComponentTitle from "../../layout/ComponentTitle";
import { useTranslation } from "react-i18next";

const ComponentFocusGouvernance = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [orgUnits, setOrgUnits] = useState([]);
  const [focusPrimaire, setFocusPrimaire] = useState("");
  const [focusSecondaire1, setFocusSecondaire1] = useState("");
  const [focusSecondaire2, setFocusSecondaire2] = useState("");
  const [focusSecondaire3, setFocusSecondaire3] = useState("");
  const [focusSecondaire4, setFocusSecondaire4] = useState("");

  const recupOrgunits = async () => {
    const res = await apiGetOrgunits(
      ReduxInstance._id
      // "filter[type]=Rituel&filter[type]=Partie prenante&filter[type]=Temps collectif"
    );

    if (res) {
      setOrgUnits(res.data);
      let indiceSecondaire = 1;
      res.data.forEach((item) => {
        if (item.focusPrimaire) {
          setFocusPrimaire(item._id);
        }
        if (item.focusSecondaire) {
          if (indiceSecondaire === 1) {
            setFocusSecondaire1(item._id);
          }
          if (indiceSecondaire === 2) {
            setFocusSecondaire2(item._id);
          }
          if (indiceSecondaire === 3) {
            setFocusSecondaire3(item._id);
          }
          if (indiceSecondaire === 4) {
            setFocusSecondaire4(item._id);
          }
          indiceSecondaire++;
        }
      });
    }
  };

  const saveFocus = async (orgunitID, type, indice = null) => {
    if (type === "focusPrimaire") {
      /* on enlève l'état du orgunit qui était déjà en focus  */
      if (focusPrimaire) {
        await apiUpdateOrgunit(focusPrimaire, { focusPrimaire: false });
      }

      /* On met à jour le nouveau focus */
      if (orgunitID) {
        await apiUpdateOrgunit(orgunitID, { focusPrimaire: true });
        setFocusPrimaire(orgunitID);
      } else {
        setFocusPrimaire("");
      }
    }

    if (type === "focusSecondaire") {
      /* focus secondaire 1 */
      if (indice === "focusSecondaire1") {
        if (focusSecondaire1) {
          await apiUpdateOrgunit(focusSecondaire1, { focusSecondaire: false });
        }
        if (orgunitID) {
          await apiUpdateOrgunit(orgunitID, { focusSecondaire: true });
          setFocusSecondaire1(orgunitID);
        } else {
          setFocusSecondaire1("");
        }
      }
      /* focus secondaire 2 */
      if (indice === "focusSecondaire2") {
        if (focusSecondaire2) {
          await apiUpdateOrgunit(focusSecondaire2, { focusSecondaire: false });
        }
        if (orgunitID) {
          await apiUpdateOrgunit(orgunitID, { focusSecondaire: true });
          setFocusSecondaire2(orgunitID);
        } else {
          setFocusSecondaire2("");
        }
      }
      /* focus secondaire 3 */
      if (indice === "focusSecondaire3") {
        if (focusSecondaire3) {
          await apiUpdateOrgunit(focusSecondaire3, { focusSecondaire: false });
        }
        if (orgunitID) {
          await apiUpdateOrgunit(orgunitID, { focusSecondaire: true });
          setFocusSecondaire3(orgunitID);
        } else {
          setFocusSecondaire3("");
        }
      }
      /* focus secondaire 4 */
      if (indice === "focusSecondaire4") {
        if (focusSecondaire4) {
          await apiUpdateOrgunit(focusSecondaire4, { focusSecondaire: false });
        }
        if (orgunitID) {
          await apiUpdateOrgunit(orgunitID, { focusSecondaire: true });
          setFocusSecondaire4(orgunitID);
        } else {
          setFocusSecondaire4("");
        }
      }
    }
  };

  useEffect(() => {
    recupOrgunits();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentTitle title={t("admin.PageAdminAlaUne.blocGouvernanceTitre")} />
      <p>{t("admin.PageAdminAlaUne.blocGouvernanceText")}</p>
      <div className="d-flex flex-column flex-lg-row zoneFocus">
        <div className="m-1 p-3 zoneFocusPrimaire align-items-center d-flex">
          <Form.Select
            name="focusPrimaire"
            value={focusPrimaire}
            onChange={(e) => saveFocus(e.target.value, "focusPrimaire")}
          >
            <option value="">{t("commun.form.placeholder.choixOrgunitPremierPlan")}</option>
            {orgUnits.map((item) => (
              <option value={item._id} key={item._id}>
                {item.enSommeil ? "⚠ " + t("admin.PageAdminOrgunits.titreColonne9") + " ⚠ - " : ""}
                {item.nom} ({item.type})
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="d-flex flex-column constainerZoneFocusSecondaire">
          <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire1"
              value={focusSecondaire1}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire1")}
            >
              <option value="">{t("commun.form.placeholder.choixOrgunitSecondPlan")}</option>
              {orgUnits.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.enSommeil
                    ? "⚠ " + t("admin.PageAdminOrgunits.titreColonne9") + " ⚠ - "
                    : ""}
                  {item.nom} ({item.type})
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire2"
              value={focusSecondaire2}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire2")}
            >
              <option value="">{t("commun.form.placeholder.choixOrgunitSecondPlan")}</option>
              {orgUnits.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.enSommeil
                    ? "⚠ " + t("admin.PageAdminOrgunits.titreColonne9") + " ⚠ - "
                    : ""}
                  {item.nom} ({item.type})
                </option>
              ))}
            </Form.Select>
          </div>
          {/* <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire3"
              value={focusSecondaire3}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire3")}
            >
              <option value="">{t("commun.form.placeholder.choixOrgunitSecondPlan")}</option>
              {orgUnits.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.enSommeil
                    ? "⚠ " + t("admin.PageAdminOrgunits.titreColonne9") + " ⚠ - "
                    : ""}
                  {item.nom} ({item.type})
                </option>
              ))}
            </Form.Select>
          </div> */}
          {/* <div className="  m-1 p-3 zoneFocusSecondaire">
            <Form.Select
              name="focusSecondaire4"
              value={focusSecondaire4}
              onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire4")}
            >
              <option value="">{t("commun.form.placeholder.choixOrgunitSecondPlan")}</option>
              {orgUnits.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.enSommeil
                    ? "⚠ " + t("admin.PageAdminOrgunits.titreColonne9") + " ⚠ - "
                    : ""}
                  {item.nom} ({item.type})
                </option>
              ))}
            </Form.Select>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ComponentFocusGouvernance;
